export default "__VITE_ASSET__Boklppt5__"